// REACT
import React, { useEffect } from "react";

// MATERIAL-UI
import { Grid } from "@mui/material";

// COMPONENTS
import Card from "./Card";

// ASSETS
import { CardStyles } from "./styles/Card.styles";
import formatCoinName from "src/utils/formatCoinName";
import { cardConstants } from "./constants";
import { TokenList } from "./types";
import api from "src/store/features/api";
import { MarketTokenDataRes } from "src/store/features/api/generated";

export interface CardSectionProps {}

const CardSection = (props: CardSectionProps) => {
  // STYLES
  const classes = CardStyles();

  // STATE
  const [recentData, setRecentData] = React.useState<TokenList[]>();
  const [trendingData, setTrendingData] = React.useState<TokenList[]>();
  const [gainersData, setGainersData] = React.useState<TokenList[]>();

  //REDUX
  const { data, isLoading } = api.useGetMarketPageCardsQuery();

  // EFFECT
  useEffect(() => {
    if (data) {
      let key: keyof typeof data;
      for (key in data) {
        const arrangedData = arrangeDataObject(data[key]);
        filterDataTypes(key, arrangedData);
      }
    }
  }, [data]);

  // DETERMINE WHICH USESTATE IS APPROPRIATE TO USE WITH WHICH DATA IS BEING FETCHED
  const filterDataTypes = (type: string, data: TokenList[]) => {
    switch (type) {
      case cardConstants.type.trending:
        setTrendingData(data);
        break;
      case cardConstants.type.recent:
        setRecentData(data);
        break;
      case cardConstants.type.gainers:
        setGainersData(data);
        break;
    }
  };

  // ARRANGE DATA TO CARD COMPONENT LIST TYPE
  const arrangeDataObject = (data: MarketTokenDataRes[]) => {
    let arrangedData = [];
    for (let item of data.slice(0, cardConstants.dataLimit)) {
      arrangedData.push({
        rank: item.rank,
        icon: item.currencyConfig?.logoUrl,
        code: item.currencyConfig.code,
        status: item.status,
        name: formatCoinName(item.currencyConfig.name),
        "24h": item.change1d,
      });
    }
    return arrangedData;
  };

  return (
    <Grid container justifyContent="space-between" className={classes.cardSectionContainer}>
      <Grid item xs className={classes.innerContainer}>
        <Card
          title={cardConstants.title.trending}
          description={cardConstants.description.trending}
          list={trendingData}
          listLoading={isLoading}
        />
      </Grid>
      <Grid item xs className={classes.innerContainer}>
        <Card
          title={cardConstants.title.gainers}
          description={cardConstants.description.gainers}
          list={gainersData}
          listLoading={isLoading}
        />
      </Grid>
      <Grid item xs className={classes.innerContainer}>
        <Card
          title={cardConstants.title.recent}
          description={cardConstants.description.recent}
          list={recentData}
          listLoading={isLoading}
        />
      </Grid>
    </Grid>
  );
};

export default CardSection;
